import React from "react";
import { useTranslation } from "react-i18next";

import { DownloadIcon } from "@chakra-ui/icons";
import { Tr, Td, Button, Flex, Badge, Tooltip, Text, useToast } from "@chakra-ui/react";
import moment from "moment";


import { API } from "../../../utils/http";
import { fullDateTimeFormat } from "../../../utils/types";

export default function FinancialStatementsRow({ propertyId, statement }) {
	const { t } = useTranslation();
	const toast = useToast();
	const getTypeLabel = (type) => {
		switch (type) {
			case "statement":
				return t("table.statement");
			case "c168":
				return t("table.c168");
			default:
				return type;
		}
	};

	const handleGetDocument = (documentId, documentName) => {
		const payload = { propertyId, documentId, financialStatementId: statement.id, documentName };
		console.log(payload);
		API.put("get-financial-statement-document", payload)
			.then((r) => {
				console.log(r);
				window.open(r.data.url, "_blank");
			})
			.catch((e) => {
				console.log(e);
				toast({
					title: "Error encountered",
					description: e.response.data.error.message,
					status: "error",
					duration: 9000,
					isClosable: true,
				});
			});
	};

	return (
		<Tr>
			<Td>{statement.name}</Td>
			<Td>
				<Badge colorScheme={statement.type === "statement" ? "blue" : "green"}>{getTypeLabel(statement.type)}</Badge>
			</Td>
			<Td>{moment(statement.createdAt).format(fullDateTimeFormat)}</Td>
			<Td>
				<Tooltip label={statement.description} hasArrow placement="top">
					<Text noOfLines={1} maxW="200px">
						{statement.description || "-"}
					</Text>
				</Tooltip>
			</Td>
			<Td>
				<Flex gap={2}>
					{statement.documents &&
						statement.documents.map((doc, idx) => (
							<Button key={idx} size="sm" leftIcon={<DownloadIcon />} onClick={() => handleGetDocument(doc.id, doc.name)} colorScheme="blue" variant="outline">
								{doc.documentName.length > 15 ? `${doc.documentName.substring(0, 12)}...` : doc.documentName}
							</Button>
						))}
					{(!statement.documents || statement.documents.length === 0) && "-"}
				</Flex>
			</Td>
		</Tr>
	);
}
